import * as api from '@api';
import { useState } from 'react';
import { useQuery } from '@/hooks/useApi';
import useToast from '@/hooks/useToast';

export default function useProductCategoriesDropdown(isDropDown = false) {
  const { toast } = useToast();
  const [categories, setCategories] = useState([]);

  useQuery(
    'productCategoriesGet',
    () =>
      api.productCategoriesGet({
        isDropDown,
      }),
    {
      onSuccess: ({ status, error, data }) => {
        if (status >= 400) {
          return toast.error(error.message);
        }
        setCategories(data?.data);
      },
      gcTime: 24 * 3600 * 1000,
    },
  );

  return categories;
}
